import React from "react";

import Tr from "./Tr"; // Importing the row component for individual table rows

export default function Table({ data, onEdit, onDelete, isAllowedToEditOrDelete }) {
  return (
    <div className="form-container">
      <table className="table">
        <thead>
          <tr>
            {/* Table headers */}
            <th className="first-col-th"><span className="extra_space_1">Name</span></th>
            <th className="text-center"><span>Depth</span></th>
            <th className="col-options">Options</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            // Display message when no data is found
            <tr>
              <td>No data found....</td>
            </tr>
          ) : (
            // Map over the data to create rows
            data.map((d, index) => (
              <Tr
                key={index} // Unique key for each row
                id={d.layer_id} // Pass layer ID as prop
                layer_name={d.layer_name} // Pass layer name as prop
                layer_depth={d.layer_depth} // Pass layer depth as prop
                pattern_id={d.pattern_id} // Pass pattern ID as prop
                onEdit={onEdit} // Function for editing a row
                onDelete={onDelete} // Function for deleting a row
                isAllowedToEditOrDelete={isAllowedToEditOrDelete} // Check permissions for editing/deleting
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
